import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { SocialItemStatus, SocialPublicationStatus } from '@/api/social'
import { ITEM_STATUS_COLOR, PUBLICATION_STATUS_COLOR } from '@/components/admin/social/socialUi'

/** Статус шага; с label — «цель: статус» для списка шагов в строке журнала */
export function SocialItemStatusChip({ status, label }: { status: SocialItemStatus; label?: string }) {
  const { t } = useTranslation()
  const text = t(`admin.social.itemStatus.${status}`)

  return (
    <Chip
      size="small"
      color={ITEM_STATUS_COLOR[status]}
      label={label ? `${label}: ${text}` : text}
      sx={{ maxWidth: '100%' }}
    />
  )
}

export function SocialPublicationStatusChip({ status }: { status: SocialPublicationStatus }) {
  const { t } = useTranslation()

  return (
    <Chip
      size="small"
      color={PUBLICATION_STATUS_COLOR[status]}
      label={t(`admin.social.publicationStatus.${status}`)}
    />
  )
}
